import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroupWrapper } from '../../../lead-generation/shared/domain/FormGroupWrapper';
import { fourByteStringValidator } from '../../../shared/validators/four-byte-string.validator';
import { MsisdnService } from '../../../shared/msisdn/msisdn.service';
import { createUniqueLabelValidator } from '../../../shared/msisdn/number-label.validator';

@Component({
  selector: 'cc-msisdn-label',
  templateUrl: './msisdn-label.component.html',
  styleUrls: ['./msisdn-label.component.scss']
})
export class MsisdnLabelComponent implements OnInit {
  @Input() placeholderText = '';
  @Input() initialValue = '';
  @Input() formWrapper: FormGroupWrapper;
  @Output() submitLabel = new EventEmitter();

  constructor(private fb: FormBuilder, private msisdnService: MsisdnService) {}

  ngOnInit() {
    if (!this.formWrapper.form) {
      this.formWrapper.form = this.fb.group({
        label: this.fb.control(
          this.initialValue,
          [Validators.required, fourByteStringValidator],
          [createUniqueLabelValidator(this.msisdnService, '')]
        )
      });
    }
  }

  onSubmit($event) {
    $event.preventDefault();
    this.submitLabel.emit(); //used as workaround to submit form with enter
    return false;
  }
}
